<template>
  <div class="home_navi" :style="homeNaviColor == 'black'? 'background: linear-gradient(180deg, #000000 0%, rgba(0,0,0,0) 100%);':''">
    <ul class="navigation">
            <li>
              <a href="https://www.jl1mall.com/forum">
                星林社区
              </a>
            </li>
            <li>
              <a href="https://www.jl1mall.com/lab">
                实验室
              </a>
            </li>
            <li>
              <a href="https://www.jl1mall.com/popular">
                科普基地
              </a>
            </li>
            <li>
              <a href="https://www.jl1mall.com/learn">
                开放学堂
              </a>
            </li>
            <li>
              <a href="https://www.jl1mall.com/contest">
                创新大赛
              </a>
            </li>
            <li>
              <a href="https://www.jl1mall.com/store">
                遥感商城
              </a>
            </li>
            <li>
              <a href="https://www.jl1mall.com/jl1release">
                一号发布
              </a>
            </li>
    </ul>
    <ul class="navigation">
    <li>
      <a href="/forum">
        星林社区
      </a>
    </li>
    <li>
      <a href="/lab">
        实验室
      </a>
    </li>
    <li>
      <a href="/popular">
        科普基地
      </a>
    </li>
    <li>
      <a href="/learn">
        开放学堂
      </a>
    </li>
    <li>
      <a href="/contest">
        创新大赛
      </a>
    </li>
    <li>
      <a href="/store">
        遥感商城
      </a>
    </li>
    <li>
      <a href="/jl1release">
        一号发布
      </a>
    </li>
    </ul>
    <div :class="homeNaviColor=='black' ? 'hoverNavi-s':'hoverNavi'" @mouseenter="showHoverNavi()" @mouseleave="closeHoverNavi()">
        <div class="hoverLogoContent" id="hoverLogoContentId"></div>
        <div class="hoverWhite" :style="homeNaviColor == 'black'? 'background: #000000;box-shadow: 2px 2px 10px 2px rgba(255,255,255,0.2);':''" id="hoverWhiteId">
            <img src="~@/assets/newHome/logo.png" alt="" class="hoverMainImg" v-if="homeNaviColor=='white'"  @click="jumpWithPermission('可游客','','/learn')">
            <img src="~@/assets/newHome/吉林一号网logo_white.png" alt="" class="hoverMainImg" v-if="homeNaviColor=='black'"  @click="jumpWithPermission('可游客','','/learn')">
            <img src="~@/assets/newHome/黑箭头.png" alt="" class="hoverJiantou" v-if="homeNaviColor=='white'" @click="jumpWithPermission('可游客','','/learn')">
            <img src="~@/assets/newHome/白箭头.png" alt="" class="hoverJiantou" v-if="homeNaviColor=='black'" @click="jumpWithPermission('可游客','','/learn')">

            <div class="hoverLine"></div>
            <div :class="homeNaviColor=='black' ? 'hoverLogo-s':'hoverLogo'" @click="jumpWithPermission('可游客','/store','/learn')" @mouseenter="showHoverLogo(7)" @mouseleave="closeHoverLogo(7)">
                <img src="~@/assets/newHome/遥感商城icon_蓝.png" alt="" class="hoverImg" style="width: 24px;height: 22px;"  v-if="homeNaviColor=='white'">
                <img src="~@/assets/newHome/遥感商城icon_white.png" alt="" class="hoverImg" style="width: 24px;height: 22px;"  v-if="homeNaviColor=='black'">
                <div class="hoverLogoText1" :style="homeNaviColor == 'black'? 'color: #fff;':''" id="hoverLogoText1Id7">遥感商城</div>
                <div class="hoverLogoText2" :style="homeNaviColor == 'black'? 'color: rgba(255,255,255,0.7);':''" id="hoverLogoText2Id7">吉林一号全品在售</div>
            </div>
            <div :class="homeNaviColor=='black' ? 'hoverLogo-s':'hoverLogo'" style="left: 252px;" @click="jumpWithPermission('仅登录','/lab','/learn')" @mouseenter="showHoverLogo(5)" @mouseleave="closeHoverLogo(5)">
                <img src="~@/assets/newHome/实验室icon_蓝.png" alt="" class="hoverImg" style="width: 30px;height: 24px;left: 22px;" v-if="homeNaviColor=='white'">
                <img src="~@/assets/newHome/实验室icon_white.png" alt="" class="hoverImg" style="width: 30px;height: 24px;left: 22px;" v-if="homeNaviColor=='black'">
                <div class="hoverLogoText1" :style="homeNaviColor == 'black'? 'color: #fff;':''" id="hoverLogoText1Id5">实验室</div>
                <div class="hoverLogoText2" :style="homeNaviColor == 'black'? 'color: rgba(255,255,255,0.7);':''" id="hoverLogoText2Id5">卫星遥感数据与AI工具</div>
            </div>
            <div :class="homeNaviColor=='black' ? 'hoverLogo-s':'hoverLogo'" style="top:167px;" @click="jumpWithPermission('可游客','/openPlatform/home','/learn')" @mouseenter="showHoverLogo(10)" @mouseleave="closeHoverLogo(10)">
                <img src="~@/assets/newHome/能力开放平台icon_蓝.png" alt="" class="hoverImg" v-if="homeNaviColor=='white'">
                <img src="~@/assets/newHome/能力开放平台icon_white.png" alt="" class="hoverImg" v-if="homeNaviColor=='black'">
                <div class="hoverLogoText1" style="width: 120px;" :style="homeNaviColor == 'black'? 'color: #fff;':''" id="hoverLogoText1Id10">能力开放平台</div>
                <div class="hoverLogoText2" :style="homeNaviColor == 'black'? 'color: rgba(255,255,255,0.7);':''" id="hoverLogoText2Id10">一站式遥感应用赋能平台</div>
            </div>
            <div :class="homeNaviColor=='black' ? 'hoverLogo-s':'hoverLogo'" style="top: 167px;left: 252px;" @click="jumpWithPermission('可游客','/edu','/learn')" @mouseenter="showHoverLogo(9)" @mouseleave="closeHoverLogo(9)">
                <img src="~@/assets/newHome/教育专区icon_蓝.png" alt="" class="hoverImg" v-if="homeNaviColor=='white'">
                <img src="~@/assets/newHome/教育专区icon_white.png" alt="" class="hoverImg" v-if="homeNaviColor=='black'">
                <div class="hoverLogoText1" :style="homeNaviColor == 'black'? 'color: #fff;':''" id="hoverLogoText1Id9">教育专区</div>
                <div class="hoverLogoText2" :style="homeNaviColor == 'black'? 'color: rgba(255,255,255,0.7);':''" id="hoverLogoText2Id9">教育认证会员专享权益</div>
            </div>
            <div :class="homeNaviColor=='black' ? 'hoverLogo-s':'hoverLogo'" style="top: 234px;" @click="jumpWithPermission('可游客','/resrepo','/learn')" @mouseenter="showHoverLogo(8)" @mouseleave="closeHoverLogo(8)">
                <img src="~@/assets/newHome/资源库icon_蓝.png" alt="" class="hoverImg" v-if="homeNaviColor=='white'">
                <img src="~@/assets/newHome/资源库icon_white.png" alt="" class="hoverImg" v-if="homeNaviColor=='black'">
                <div class="hoverLogoText1" :style="homeNaviColor == 'black'? 'color: #fff;':''" id="hoverLogoText1Id8">资源库</div>
                <div class="hoverLogoText2" :style="homeNaviColor == 'black'? 'color: rgba(255,255,255,0.7);':''" id="hoverLogoText2Id8">一站式遥感资源中心</div>
            </div>
            <!-- <div :class="homeNaviColor=='black' ? 'hoverLogo-s':'hoverLogo'" style="top: 234px;left: 252px;" @click="jumpWithPermission('可游客','/forum','/learn')" @mouseenter="showHoverLogo(2)" @mouseleave="closeHoverLogo(2)">
                <img src="~@/assets/newHome/星林社区icon_蓝.png" alt="" class="hoverImg" v-if="homeNaviColor=='white'">
                <img src="~@/assets/newHome/星林社区icon_white.png" alt="" class="hoverImg" v-if="homeNaviColor=='black'">
                <div class="hoverLogoText1" :style="homeNaviColor == 'black'? 'color: #fff;':''" id="hoverLogoText1Id2">星林社区</div>
                <div class="hoverLogoText2" :style="homeNaviColor == 'black'? 'color: rgba(255,255,255,0.7);':''" id="hoverLogoText2Id2">遥感应用知识交流分享</div>
            </div> -->
            <div :class="homeNaviColor=='black' ? 'hoverLogo-s':'hoverLogo'" style="top: 234px;left: 252px;" @click="jumpWithPermission('仅登录','/learn','/learn')" @mouseenter="showHoverLogo(3)" @mouseleave="closeHoverLogo(3)">
                <img src="~@/assets/newHome/开放学堂icon_蓝.png" alt="" class="hoverImg" style="width: 24px;height: 18px;" v-if="homeNaviColor=='white'">
                <img src="~@/assets/newHome/开放学堂icon_white.png" alt="" class="hoverImg" style="width: 24px;height: 18px;" v-if="homeNaviColor=='black'">
                <div class="hoverLogoText1" :style="homeNaviColor == 'black'? 'color: #fff;':''" id="hoverLogoText1Id3">开放学堂</div>
                <div class="hoverLogoText2" :style="homeNaviColor == 'black'? 'color: rgba(255,255,255,0.7);':''" id="hoverLogoText2Id3">手把手教你用吉林一号</div>
            </div>
            <div :class="homeNaviColor=='black' ? 'hoverLogo-s':'hoverLogo'" style="top: 301px;" @click="jumpWithPermission('可游客','/contest','/learn')" @mouseenter="showHoverLogo(4)" @mouseleave="closeHoverLogo(4)">
                <img src="~@/assets/newHome/创新大赛icon_蓝.png" alt="" class="hoverImg" style="width: 23px;"  v-if="homeNaviColor=='white'">
                <img src="~@/assets/newHome/创新大赛icon_white.png" alt="" class="hoverImg" style="width: 23px;"  v-if="homeNaviColor=='black'">
                <div class="hoverLogoText1" :style="homeNaviColor == 'black'? 'color: #fff;':''" id="hoverLogoText1Id4">创新大赛</div>
                <div class="hoverLogoText2" :style="homeNaviColor == 'black'? 'color: rgba(255,255,255,0.7);':''" id="hoverLogoText2Id4">卫星和你创未来</div>
            </div>
            <div :class="homeNaviColor=='black' ? 'hoverLogo-s':'hoverLogo'" style="top: 301px;left: 252px;" @click="jumpWithPermission('可游客', '/jl1release', '/learn')" @mouseenter="showHoverLogo(1)" @mouseleave="closeHoverLogo(1)">
                <img src="~@/assets/newHome/一号发布icon_蓝.png" alt="" class="hoverImg" v-if="homeNaviColor=='white'">
                <img src="~@/assets/newHome/一号发布icon_white.png" alt="" class="hoverImg" v-if="homeNaviColor=='black'">
                <div class="hoverLogoText1" :style="homeNaviColor == 'black'? 'color: #fff;':''" id="hoverLogoText1Id1">一号发布</div>
                <div class="hoverLogoText2" :style="homeNaviColor == 'black'? 'color:rgba(255,255,255,0.7)':''" id="hoverLogoText2Id1">遥感专题资讯及数据集</div>
            </div>
            <div :class="homeNaviColor=='black' ? 'hoverLogo-s':'hoverLogo'" @click="jumpWithPermission('可游客','/popular','/learn')" style="top: 368px;" @mouseenter="showHoverLogo(6)" @mouseleave="closeHoverLogo(6)">
                <img src="~@/assets/newHome/科普基地icon_蓝.png" alt="" class="hoverImg" v-if="homeNaviColor=='white'">
                <img src="~@/assets/newHome/科普基地icon_whilte.png" alt="" class="hoverImg" v-if="homeNaviColor=='black'">
                <div class="hoverLogoText1" :style="homeNaviColor == 'black'? 'color: #fff;':''" id="hoverLogoText1Id6">科普基地</div>
                <div class="hoverLogoText2" :style="homeNaviColor == 'black'? 'color: rgba(255,255,255,0.7);':''" id="hoverLogoText2Id6">吉林一号进万家</div>
            </div>   
        </div>

    </div>
      <div class="menuLine1"></div>
      <img src="~@/assets/newHome/开放学堂浅底logo.png" alt="" class="logo" v-if="homeNaviColor=='white'">
      <img src="~@/assets/newHome/开放学堂logo_white.png" alt="" class="logo" v-if="homeNaviColor=='black'">
      <div class="menu">
          <div class="menuText1" :style="homeNaviColor == 'black'? 'color: #fff;':''" @click="$router.push('/');">学堂首页</div>
          <div class="menuText1" style="left: 96px;" :style="homeNaviColor == 'black'? 'color: #fff;':''" @click="jumpWithLoginCheck('/globalCourse')">线上课堂</div>
          <div class="menuText1" style="left: 192px;" :style="homeNaviColor == 'black'? 'color: #fff;':''" @click="jumpWithLoginCheck('/courseDetail')">
            线下培训
          </div>
          <!-- <div class="menuText1" style="left: 288px;" :style="homeNaviColor == 'black'? 'color: #fff;':''" @click="jumpForum()">星林社区</div> -->
        </div>
      <div class="homeNaviText" :style="homeNaviColor == 'black'? 'color: #fff;':''" @click="jumpWithPermission('可游客','','/learn')">返回主站</div>
      <div class="menuLine"></div>
      <div class="contract" :style="homeNaviColor == 'black'? 'color: #fff;border:1px solid #fff':''" @click="connectStatus=true">联系我们</div>
      <div class="login" @click="jumpWithPermission('仅登录','/Login','/learn')" v-if="!$store.state.user.logined">登录</div>
      <div class="login-s" @mouseenter="showLoginPanel = true" @mouseleave="showLoginPanel = false"
         v-if="$store.state.user.logined">
      <img src="../assets/HomeNavi/默认头像.png" alt="" class="loginIcon"
           v-if="avatar == '' || avatar == undefined || avatar == null">
           
      <div v-if="messageStatus" class="messageTip" style="top:0px;right:0px;"></div>
      <img v-if="avatar" :src="avatar" class="loginIcon"/>
      <div class="loginOperateCtn" v-show="showLoginPanel">
        <div class="loginName" v-if="authenticationStatus=='0'" style="margin-top: 10px;">您好，{{ $store.state.user.name }}</div>
        <!-- <div class="loginName" v-if="authenticationStatus=='0'">已实名用户</div>
        <div class="loginText" v-if="authenticationStatus=='1'"
             @click="$router.push('/Authentication')"
             style="color:#0066cc;margin-top: 5px;">去实名认证
        </div> -->
        <div @click="$router.push({path:'universityUserCenter',query:{'type':1}});" class="loginOperateItem" style="margin-top: 0px">
          我的报名
        </div>
        <div @click="$router.push({path:'universityUserCenter',query:{'type':2}});" class="loginOperateItem">
          我的课程
        </div>
        <div @click="$router.push({path:'universityUserCenter',query:{'type':3}});" class="loginOperateItem">
          我的作业
        </div>
        <div @click="$router.push({path:'universityUserCenter',query:{'type':4}});" class="loginOperateItem" style="position:relative">
          我的消息
          <div v-if="messageStatus" class="messageTip" style="top:13px;right:59px;"></div>
        </div>
          <div v-if="teacherStatus=='1'" @click="$router.push({path:'teachingManage'})" class="loginOperateItem">
              讲师工作台
          </div>
        <div class="loginLine"></div>
        <div class="loginText" @click="
          setLocalStorageItem('userId', '');
          $store.state.user.logined = false;
          axios.get('/loginapi/logout', {
              headers: { Authorization: 'Bearer ' + getKey() },
          });
          setLocalStorageItem('token','');
          goHome()
          ">退出
        </div>
      </div>
    </div>
      <div class="shadow" v-if="connectStatus">
          <div class="dialog2" >
              <img src="~@/assets/newHome/关闭.png" alt="" class="dialogImg1" @click="connectStatus=false"/>               
              <img src="https://market.obs.cn-north-4.myhuaweicloud.com/jl1mall/lianxiren.png" alt="" class="dialogImg4" />
              <div class="guanwang" @click="goGuanwang()"></div>
          </div>
      </div>
  </div>

   
</template>
<script>
import {rootUrl} from '@/globalConfig'
export default {
  name: "HomeNavi",
  inject: ["reload"],
  data() {
      return {
          showLoginPanel: false,
          avatar:"",
          connectStatus:false,
          authenticationStatus:'1',//实名状态，0：已实名，1：未实名
          homeNaviColor:'white',
          messageStatus:false,
          teacherStatus:0,
      }
  },
  mounted(){
      // this.checkAndHandleAuthentication();
      let routePath=this.$route.path
      if(routePath=='/'||routePath=='/courseDetail'||routePath=='/directSeeding'){
          this.homeNaviColor = 'black'
      }
      const isMobile = /iPhone|iPad|iPod|Android/i.test(navigator.userAgent);
      if (isMobile) {
        console.log("手机");
      } else {
        console.log("pc端");
        this.getLoginInfo();
        //定时判断用户登录状态，每分钟一次，如果是登录超时则返回登录页
        this.$nextTick(() => {
          setInterval(this.getIfTimeout, 600000);
        });
      }
      
     

  },
  methods:{
      //实名权限检查与处理（培训班版）
      checkAndHandleAuthentication(){
        console.log("进入实名检查")
        let loginUserId=localStorage.getItem('userId');//是否已登录
        let authentication=localStorage.getItem('authentication');//0:已实名；1：未实名
        console.log(loginUserId,authentication)
        console.log(localStorage.getItem('preRoute'))
        if(!loginUserId){
          //上线前修改
          // this.$router.push("/Login")
          this.jumpWithPermission('仅登录','/Login','/learn/')
        }
        else if(authentication!='0'){
          this.jumpWithPermission('仅实名','/Authentication','/learn/')
        }
        return true;
      },
      getKey() {
          return localStorage.getItem("token");
      },
      //项目内需登录路由跳转：已登录则 SPA 内正常跳转；未登录跳转登录页，登录成功回跳首页
      jumpWithLoginCheck(path){
        let loginUserId = localStorage.getItem('userId');
        if (loginUserId) {
          this.$router.push(path)
        } else {
          this.jumpWithPermission('仅登录','/Login','/learn')
        }
      },
      //带权限判断的跳转
      jumpWithPermission(type,path,fromUrl){
        //path:需要跳转到的路由；fromUrl：如果权限不满足，满足后回跳的路由
        //注意：fromUrl必须为包含本项目router中base的相对地址，如商城个人中心为：/store/UserCenter
        let loginUserId=localStorage.getItem('userId');//是否已登录
        let authentication=localStorage.getItem('authentication');//0:已实名；1：未实名
        if(type=='可游客'){
          if(fromUrl){
            window.open(rootUrl+path+"?fromUrl="+rootUrl+fromUrl,"_self")
          }
          else {
            window.open(rootUrl+path,"_self")
          }
        }else if(type=='仅登录'){
          //已登录
          if(loginUserId){
            if(fromUrl){
              window.open(rootUrl+path+"?fromUrl="+rootUrl+fromUrl,"_self")
            }
            else {
              window.open(rootUrl+path,"_self")
            }
          }
          //未登录
          else {
            if(fromUrl){
              window.open(rootUrl+'/Login'+"?fromUrl="+rootUrl+fromUrl,"_self")
            }
            else {
              window.open(rootUrl+'/Login',"_self")
            }
          }
        }else if(type=='仅实名'){
          //已登录
          if(loginUserId){
            //已实名
            if(authentication=='0'){
              if(fromUrl){
                window.open(rootUrl+path+"?fromUrl="+rootUrl+fromUrl,"_self")
              }
              else {
                window.open(rootUrl+path,"_self")
              }
            }
            //未实名
            else {
              window.open(rootUrl+'/Authentication',"_self")
            }

          }
          //未登录
          else {

            if(fromUrl){
              window.open(rootUrl+'/Login'+"?fromUrl="+rootUrl+fromUrl,"_self")
              // this.$router.push('/Login')
            }
            else {
              window.open(rootUrl+'/Login',"_self")
            }
          }
        }
      },
      getLoginInfo() {
      this.axios
          .get("/loginapi/getLoginInfo", {
            headers: {'Cache-Control': 'no-cache',
              Authorization: "Bearer " + this.getKey(),
            },
          })
          .then((res) => {
            if (res.data.success) {
              console.log(res);
              this.print(res.data);
              this.$store.state.user.userId = res.data.data.account;
              this.$store.state.user.name = res.data.data.name;
              this.$store.state.user.vipLevel = res.data.data.vipLevel;
              this.setCookie("userId", res.data.data.account);
              this.setCookie("userInfo",JSON.stringify({phone: res.data.data.phone,location: res.data.data.location,}));
              this.$store.state.user.logined = true;
              let authentication = res.data.data.authentication
              this.$store.state.user.authentication =authentication; //是否实名认证，0是，1否
              this.setLocalStorageItem("authentication",authentication); //是否实名认证，0是，1否;为方便其他系统用
              this.setLocalStorageItem('token',res.data.data.key); //getuserInfo也需要赋值token，为把三部token替换为本部门token
              this.authenticationStatus=authentication
              this.vipLevel = res.data.data.vipLevel;
              this.vipType = res.data.data.vipType;
              this.vipActivityStatus = res.data.data.vipActivityStatus;
              this.avatar = res.data.data.avatar;
              if (res.data.data.endTime) {
                this.vip_endTime = res.data.data.endTime.split(" ")[0];
              }
              this.axios
              .get("/learn_back/course/register/getUserInfo", {
                  headers: {'Cache-Control': 'no-cache',
                  Authorization: "Bearer " + this.getKey(),
                  },
              })
              .then((res) => {
                if(res.data.code==200){
                  this.teacherStatus=res.data.data.teacherStatus;
                  this.messageStatus=res.data.data.messageStatus;
                  this.graduationStatus=res.data.data.graduationStatus;
                  this.excellent=res.data.data.excellent;
                }
              });
            } else {
              this.$store.state.user.logined = false;
              // 首页允许游客查看：未登录时首页不强制跳转登录，仅隐藏已登录信息
              if (this.$route.path == '/') {
                return;
              }
              if (this.getCookie("userId")) {
                  this.$store.state.user.logined = false;
                  setTimeout(() => {
                    this.$store.state.user.userId = "";
                    this.setCookie('userId', "");
                    localStorage.setItem("userId", "");
                    this.jumpWithPermission('仅登录','/Login','/learn')
                  }, 2000);
              }else {
                      this.jumpWithPermission('仅登录','/Login','/learn')
                  }
            }
          });
    },
      setLocalStorageItem(key, value) {
          localStorage.setItem(key, value);
      },
      getIfTimeout(){
        this.axios
          .get("/loginapi/getLoginInfo", {
            headers: {'Cache-Control': 'no-cache',
              Authorization: "Bearer " + this.getKey(),
            },
          })
          .then((res) => {
            if (res.data.success) {
              console.log(res);
              this.setCookie("userId", res.data.data.account);
              this.setCookie("userInfo",JSON.stringify({phone: res.data.data.phone,location: res.data.data.location,}));
              this.$store.state.user.logined = true;
              this.setLocalStorageItem('authentication',res.data.data.authentication); //是否实名认证，0是，1否;为方便其他系统用
              this.setLocalStorageItem('token',res.data.data.key); //getuserInfo也需要赋值token，为把三部token替换为本部门token
            } else {
                this.$store.state.user.logined = false;
                // 首页允许游客查看：未登录时不强制跳转登录
                if (this.$route.path == '/') {
                    return;
                }
                if (this.getCookie("userId")) {
                    this.$store.state.user.logined = false;
                    setTimeout(() => {
                      this.$store.state.user.userId = "";
                      this.setCookie('userId', "");
                      localStorage.setItem("userId", "");
                      this.jumpWithPermission('仅登录','/Login','/learn')
                    }, 2000);
                }else {
                        this.jumpWithPermission('仅登录','/Login','/learn')
                    }
              }
          });
      },
      
      refreshLocation() {
          location.reload();
          window.scrollTo({
              top: 0,
              left: 0,
              behavior: "instant",
          });
      },
      goHome(){
          this.$router.push('/')
      },
      showHoverNavi(){
          let hoverLogoContentId = document.getElementById("hoverLogoContentId");
          hoverLogoContentId.style.width = "44px";
          hoverLogoContentId.style.height = "100px";
          let hoverWhite = document.getElementById("hoverWhiteId");
          hoverWhite.style.width = "500px";
          hoverWhite.style.height = "450px";
      },
      closeHoverNavi(){
          let hoverLogoContentId = document.getElementById("hoverLogoContentId");
          hoverLogoContentId.style.width = "0px";
          hoverLogoContentId.style.height = "0px";
          let hoverWhite = document.getElementById("hoverWhiteId");
          hoverWhite.style.width = "0px";
          hoverWhite.style.height = "0px";
      },
      showHoverLogo(i){
          let hoverLogoText1Id = document.getElementById("hoverLogoText1Id"+i);
          hoverLogoText1Id.style.top = "6px";
          let hoverLogoText2Id = document.getElementById("hoverLogoText2Id"+i);
          hoverLogoText2Id.style.opacity = 1;   
      },
      closeHoverLogo(i){
          let hoverLogoText1Id = document.getElementById("hoverLogoText1Id"+i);
          hoverLogoText1Id.style.top = "17px";
          let hoverLogoText2Id = document.getElementById("hoverLogoText2Id"+i);
          hoverLogoText2Id.style.opacity = 0;   
      },
      goGuanwang(){
        window.open("http://www.jl1.cn/")
      },
      jumpForum(){
        window.open('https://www.jl1mall.com/forum?specialDomanId=20240520150900005395')
      }
  }
}
</script>

<style scoped>
.home_navi {
background: #fff;
/* background-image: url(); */
width: 100%;
height: 76px;
position: fixed;
z-index: 1000;
top: 0px;
}
.navigation{
      position:absolute;
      top:20px;
      left:500px;
      width: 1px;
      height:1px;
      overflow: hidden;
}
.hoverNavi{
  position: absolute;
  width: 44px;
  height: 44px;
  top: 16px;
  left: 20px;
  background-image: url('~@/assets/newHome/导航按钮.png');
  cursor: pointer;
}
.hoverNavi:hover{
  background-image: url('~@/assets/newHome/导航按钮hover.png');
  /* background-color: pink; */
}
.hoverNavi-s{
  position: absolute;
  width: 44px;
  height: 44px;
  top: 16px;
  left: 20px;
  background-image: url('~@/assets/newHome/导航按钮_黑底.png');
  cursor: pointer;
}
.hoverNavi-s:hover{
  background-image: url('~@/assets/newHome/导航按钮_黑底_hover.png');
  /* background-color: pink; */
}
.hoverLogoContent{
  position: fixed;
  top: 60px;
  left: 20px;
  width: 0px;
  height: 0px;
  overflow: hidden;
}
.hoverWhite{
  position: fixed;
  top: 76px;
  left: 20px;
  width: 0px;
  height: 0px;
  background: #FFFFFF;
  box-shadow: 2px 2px 10px 2px rgba(0,0,0,0.2);
  border-radius: 16px;
  transition: 0.3s;
  overflow: hidden;
}

.hoverMainImg{
  position: absolute;
  top: 20px;
  left: 44px;
  width: 175px;
  height: 40px;
}
.hoverJiantou{
  position: absolute;
  width: 18px;
  height: 16px;
  top: 35px;
  left: 433px;
}
.hoverLine{
  position: absolute;
  top: 80px;
  left: 28px;
  width: 444px;
  height: 1px;
  border-top: 1px solid #CCCCCC;
}
.hoverLogo{
  position: absolute;
  top: 100px;
  left: 28px;
  width: 220px;
  height: 60px;
  background: #fff;
  border-radius: 6px;
  }
.hoverLogo:hover{
background: #F7F7F7;
}
.hoverLogo-s{
  position: absolute;
  top: 100px;
  left: 28px;
  width: 220px;
  height: 60px;
  background: #000;
  border-radius: 6px;
  }
.hoverLogo-s:hover{
background: rgba(0,0,0,0.7);
}
.hoverImg{
  position: absolute;
  top: 19px;
  left: 24px;
  width: 20px;
  height: 20px;
}
.hoverLogoText1{
  position: absolute;
  top: 17px;
  left: 66px;
  width: 85px;
  height: 24px;
  font-size: 20px;
  font-family: Tensentype-ZhiHeiJ-W4, Tensentype-ZhiHeiJ;
  font-weight: normal;
  color: #3A3A3A;
  line-height: 24px;
}
.hoverLogoText2{
  position: absolute;
  top: 35px;
  left: 66px;
  width: 133px;
  height: 17px;
  font-size: 12px;
  font-family: PingFangSC-Light, PingFang SC;
  font-weight: 300;
  color: #979797;
  line-height: 17px;
  opacity: 0;
}
.menuLine1{
  position: absolute;
  top: 18px;
  left: 85px;
  width: 1px;
  height:40px;
  background-color:  #CCCCCC;
  opacity: 0.8;
}
.logo{
  position: absolute;
  top: 18px;
  left: 118px;
  width: 155px;
  height: 49px;
}
.menu{
  position: absolute;
  width:346px;
  height: 20px;
  top: 28px;
  left: calc(50% - 173px);
  /* background-color: grey; */
}
.menuText1{
  position: absolute;
  width: 60px;
  height: 20px;
  font-size: 14px;
  font-family: PingFangSC-Regular, PingFang SC;
  font-weight: 400;
  color: #3A3A3A;
  line-height: 20px;
  cursor: pointer;
}
.menuText3{
position: absolute;
top: 23px;
left: 165px;
width: 100px;
height: 14px;
font-size: 10px;
font-family: PingFangSC-Regular, PingFang SC;
font-weight: 400;
color: #FF6666;
line-height: 14px;
}
.homeNaviText{
  position: absolute;
  top: 28px;
  right: 350px;
  width: 60px;
  height: 20px;
  font-size: 14px;
  font-family: PingFangSC-Regular, PingFang SC;
  font-weight: 400;
  color: #3A3A3A;
  line-height: 20px;
  cursor: pointer;
}
.menuText2{
  position: absolute;
  width: 56px;
  left: 622px;
height: 20px;
font-size: 14px;
font-family: PingFangSC-Regular, PingFang SC;
font-weight: 400;
color: #3A3A3A;
line-height: 20px;
background: linear-gradient(118deg, #D65FFF 0%, #00CBFF 100%);
-webkit-background-clip: text;
-webkit-text-fill-color: transparent;
cursor: pointer;
}
.menuLine{
  position: absolute;
  top: 18px;
  right: 308px;
  width: 1px;
  height:40px;
  background-color:  #CCCCCC;
  opacity: 0.8;
}
.contract{
  position: absolute;
  top: 18px;
  right: 130px;
  width:128px;
  height:40px;
  border-radius: 8px;
  border: 1px solid #3A3A3A;
  font-size: 14px;
  font-family: PingFangSC-Regular, PingFang SC;
  font-weight: 400;
  color: #3A3A3A;
  line-height: 40px;
  text-align: center;
  cursor: pointer;
}
.login{
  position: absolute;
  top: 11px;
  right: 30px;
  width: 54px;
  height: 54px;
  background: #EAEAEA;
  border-radius: 50%;
  font-size: 14px;
  font-family: PingFangSC-Regular, PingFang SC;
  font-weight: 400;
  color: #3A3A3A;
  line-height: 54px;
  text-align: center;
  cursor: pointer;
}
.login-s{
  position: absolute;
  top: 11px;
  right: 54px;
  width: 54px;
  height: 66px;
  cursor: pointer;
}
.loginIcon{
  position: absolute;
  top: 0;
  left: 0;
  width: 54px;
  height: 54px;
}
.loginOperateCtn{
  position: absolute;
  top: 66px;
  right: 0px;
  width: 200px;
  min-height: 100px;

  background: #FFFFFF;
  box-shadow: 2px 2px 10px 0px rgba(0,0,0,0.25);
  border-radius: 16px;
}
.loginName{
  width: 200px;
  height: 50px;
  font-size: 16px;
  font-family: PingFangSC-Semibold, PingFang SC;
  font-weight:400;
  color: #CCCCCC;
  line-height: 50px;
  text-align: center;
}

.loginOperateItem{
width: 100%;
height: 48px;
line-height: 48px;
font-size: 16px;
font-family: PingFangSC-Regular, PingFang SC;
color: #2b2b2b;
text-align: center;
cursor:pointer;
}
.messageTip{
position:absolute;
width: 6px;
height: 6px;
background: #FF4040;
border-radius: 3px;
}
.loginLine{

  width: 120px;
margin-left: auto;
margin-right: auto;
height: 1px;
background: #D8D8D8;

}
.loginText{

  width: 200px;
height: 50px;
font-size: 16px;
font-family: PingFangSC-Regular, PingFang SC;
font-weight: 600;
color: #3A3A3A;
line-height: 50px;
text-align: center;
cursor: pointer;
}
.shadow{
position: fixed;
top: 0;
width: 100%;
height:100%;
background-color: rgba(0, 0, 0, 0.4);
z-index: 10000;
}
.dialog2 {
  position: absolute;
width: 600px;
height: 400px;
border-radius: 16px;
left: calc(50% - 300px);
top: calc(50% - 200px);
z-index: 10001;
background: #ffffff;
}
.dialogImg1{
  position: absolute;
  top: 0;
  right: -50px;
  cursor: pointer;
}
.dialogImg4 {
position: absolute;
width: 505px;
height: 306px;
top: calc(50% - 153px);
left: calc(50% - 252px);
}
.guanwang{
  position: absolute;
  /* background-color: pink; */
  width: 100px;
  height: 20px;
  top: 277px;
  left: 440px;
  cursor: pointer;
}
.dialogText1 {
  position: absolute;
top: 69px;
left: calc(50% - 300px);
width: 600px;
height: 24px;
font-size: 18px;
font-family: PingFangSC-Medium, PingFang SC;
font-weight: 600;
color: #1d1d28;
line-height: 25px;
text-align: center;
}
.dialogImg2{
  position: absolute;
  left: 156px;
  top: 144px;
}
.dialogText2 {
position: absolute;
top: 140px;
left: 190px;
width: 300px;
height: 22px;
font-size: 16px;
font-family: PingFangSC-Light, PingFang SC;
font-weight: 300;
color: #1d1d28;
line-height: 22px;
}
.dialogText3 {
  position: absolute;
  top: 165px;
  left: 190px;
width: 208px;
height: 22px;
font-size: 16px;
font-family: PingFangSC-Light, PingFang SC;
font-weight: 300;
color: #1d1d28;
line-height: 22px;
text-align: center;
}
.dialogText4 {
position: absolute;

top: 214px;
  left: 190px;
width: 120px;
height: 22px;
font-size: 16px;
font-family: PingFangSC-Light, PingFang SC;
font-weight: 300;
color: #1d1d28;
line-height: 22px;
}
.hideToConsultation {
position: absolute;
left: calc(50% - 48px);
top: 300px;
width: 96px;
height: 44px;
background: #1E81EB;
border-radius: 22px;
font-size: 16px;
font-family: PingFangSC-Semibold, PingFang SC;
font-weight: 600;
color: #ffffff;
line-height: 44px;
text-align: center;
cursor: pointer;
}
</style>
